import React, { FC } from "react";
import { Icon } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { CopyTaskMessage, CopyTaskMessageContainer } from "../../CopyResource/components/Layer/styled";
import { useUploadDataContext } from "../uploadDataContext";
import { declension } from "../../../../utils/declension";

export const UploadFinish: FC<{ error: string }> = ({ error = "" }) => {
  const { t, i18n } = useTranslation();
  const { uploadedFiles } = useUploadDataContext();

  return (
    <CopyTaskMessageContainer success={!error} error={!!error}>
      <Icon kind={error ? "warning" : "success"} />
      <div>
        {error ? t("actions.error", { ns: "common" }) : t("actions.ready", { ns: "common" })}
        <CopyTaskMessage success={!error} error={!!error}>
          {error || (
            <>
              {i18n.language === "en" ? (
                <>
                  {uploadedFiles.length} {uploadedFiles.length === 1 ? "raster" : "rasters"} uploaded
                </>
              ) : (
                <>
                  {declension("Загружен", "Загружено", "Загружено", uploadedFiles.length)}
                  &nbsp;{uploadedFiles.length}&nbsp;
                  {declension("растр", "растров", "растра", uploadedFiles.length)}
                </>
              )}
            </>
          )}
        </CopyTaskMessage>
      </div>
    </CopyTaskMessageContainer>
  );
};
